module.exports = __webpack_public_path__ + "img/yx1.57e26d68.png";